import { BasicCommonSize, CommonSize } from '../../common/helpers/utils';
import { InputProps } from './integrated-form-control';

export function mapInputSizeToCommonSize(
    inputProps: InputProps
): Omit<InputProps, 'size'> & { size?: BasicCommonSize } {
    const { size, ...rest } = inputProps;
    let mappedSize: CommonSize | undefined;
    switch (size) {
        case 'sm':
        case 'md':
        case 'lg':
        case undefined:
            mappedSize = size;
            break;
        case 'xl':
            mappedSize = 'lg';
            break;
    }
    return { ...rest, size: mappedSize };
}
